import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	resetColumnsErrorTitle: {
		id: 'issue-view-common-views.child-issues-panel.configurable-child-issues-panel.reset-columns-error-title',
		defaultMessage: "We couldn't restore the default columns",
		description:
			"Displayed as error flag's title when an unexpected error happens while user is trying to configure columns in a table.",
	},
	getChildIssueErrorTitle: {
		id: 'issue-view-common-views.child-issues-panel.configurable-child-issues-panel.get-child-issue-error-title',
		defaultMessage: "We couldn't get your child issues",
		description:
			"Displayed as error flag's title when an unexpected error happens while user is trying to load child issue table.",
	},
	getChildIssueErrorDescription: {
		id: 'issue-view-common-views.child-issues-panel.configurable-child-issues-panel.get-child-issue-error-description',
		defaultMessage: 'Refresh and try again.',
		description:
			"Displayed as error flag's description when an unexpected error happens while user is trying to load child issue table.",
	},
	getChildIssueErrorTitleIssueTermRefresh: {
		id: 'issue-view-common-views.child-issues-panel.configurable-child-issues-panel.get-child-issue-error-title-issue-term-refresh',
		defaultMessage: "We couldn't get your child work items",
		description:
			"Displayed as error flag's title when an unexpected error happens while user is trying to load child issue table.",
	},
});
